import { eqBy,prop, unionWith } from "ramda";

export const defaultScopeId = "v3.workflow";

export const SUBSCRIBE = "WORKFLOWS/SUBSCRIBE";
export const UNSUBSCRIBE = "WORKFLOWS/UNSUBSCRIBE";
export const UPDATE_MANY = "WORKFLOWS/UPDATE_MANY";
export const LOAD_SUCCEEDED = "WORKFLOWS/LOAD_SUCCEEDED";
export const LOAD_FAILED = "WORKFLOWS/LOAD_FAILED";
export const LOAD_REQUESTED = "WORKFLOWS/LOAD_REQUESTED";
export const CREATE_REQUESTED = "WORKFLOWS/CREATE_REQUESTED";
export const UPDATE_REQUESTED = "WORKFLOWS/UPDATE_REQUESTED";
export const CREATE_SUCCEEDED = "WORKFLOWS/CREATE_SUCCEEDED";
export const UPDATE_SUCCEEDED = "WORKFLOWS/UPDATE_SUCCEEDED";
export const CREATE_FAILED = "WORKFLOWS/CREATE_FAILED";
export const UPDATE_FAILED = "WORKFLOWS/UPDATE_FAILED";
export const ARCHIVE_REQUESTED = "WORKFLOWS/ARCHIVE_REQUESTED";
export const ARCHIVE_SUCCEEDED = "WORKFLOWS/ARCHIVE_SUCCEEDED";
export const REPLY_SUCCEEDED = "WORKFLOWS/REPLY_SUCCEEDED";
export const ARCHIVE_FAILED = "WORKFLOWS/ARCHIVE_FAILED";

const findById = workflowId => ({ id }) =>  workflowId === id;
const mergeWorkflowsById = unionWith(eqBy(prop("id")));

// eslint-disable-next-line complexity, max-statements
export default (state = {
    archiving: 0,
    creating: 0, 
    errors: [], 
    hasInitialData: false,
    loading: 0, 
    subscriptions: 0,
    updating: 0, 
    workflows: [],
}, { type, data }) => {
    switch (type) {
    case SUBSCRIBE: {
        ++state.subscriptions;
        return state;
    }
    case UNSUBSCRIBE: {
        --state.subscriptions;
        return state;
    }
    case UPDATE_MANY: {
        state.hasInitialData = true;
        state.workflows = mergeWorkflowsById(data.workflows, state.workflows);
        return state;
    }
    case LOAD_REQUESTED: {
        ++state.loading;
        const { workflowId } = data;
        const workflow = state.workflows.find(findById(workflowId));
        if (workflow){
            workflow.loading = true;
        }
        return state;
    }
    case LOAD_FAILED: {
        --state.loading;
        const { workflowId, error } = data;
        const workflow = state.workflows.find(findById(workflowId));
        if (workflow){
            workflow.loading = false;
            workflow.error = error;
        }
        state.errors.push({ error, workflowId, type });
        return state;
    }
    case LOAD_SUCCEEDED: {
        --state.loading;
        state.hasInitialData = true;
        const { workflowId, ...properties } = data;
        Object.assign(state.workflows.find(findById(workflowId)) || {}, properties, {
            loading: false
        });
        return state;
    }
    case UPDATE_SUCCEEDED:  {
        const { id , ...properties } = data;
        Object.assign(state.workflows.find(findById(id)) || {}, properties, {
            updating: false
        });
        --state.updating;
        return state;
    }
    case ARCHIVE_SUCCEEDED: {
        const { id , archived } = data;
        const workflow = state.workflows.find(findById(id));
        if (workflow){
            workflow.archived = archived;
            workflow.archiving = false;
        }
        --state.archiving;
        return state;
    }
    case REPLY_SUCCEEDED:
    case CREATE_SUCCEEDED: {
        state.workflows.push(data);
        --state.creating;
        return state;
    }
    case UPDATE_REQUESTED:  {
        const { workflowId } = data;
        const workflow = state.workflows.find(findById(workflowId));
        if (workflow){
            workflow.updating = true;
        }
        ++state.updating;
        return state;
    }
    case ARCHIVE_REQUESTED: {
        const { workflowId } = data;
        const workflow = state.workflows.find(findById(workflowId));
        if (workflow){
            workflow.archiving = true;
        }
        ++state.archiving;
        return state;
    }
    case CREATE_REQUESTED:  {
        ++state.creating;
        return state;
    }
    case UPDATE_FAILED:  {
        const { workflowId, error } = data;
        const workflow = state.workflows.find(findById(workflowId));
        if (workflow){
            workflow.updating = false;
            workflow.error = error;
        }
        state.errors.push({ error, workflowId, type });
        state.lastError = error;
        --state.updating;
        return state;
    }
    case ARCHIVE_FAILED: {
        const { workflowId, error } = data;
        const workflow = state.workflows.find(findById(workflowId));
        if (workflow){
            workflow.archiving = false;
            workflow.error = error;
        }
        state.errors.push({ error, workflowId, type });
        state.lastError = error;
        --state.archiving;
        return state;
    }
    case CREATE_FAILED:  {
        const { workflowId, error } = data;
        state.errors.push({ error, workflowId, type });
        state.lastError = error;
        --state.creating;
        return state;
    }
    default: return state;
    }
};

export const subscribeToWorkflow = ({ workflowId }) => ({ type: SUBSCRIBE, data: { workflowId } });
export const unsubscribeFromWorkflow = ({ workflowId }) => ({ type: UNSUBSCRIBE, data: { workflowId } });
export const successLoadWorkflow = data => ({ type: LOAD_SUCCEEDED, data });
export const failLoadWorkflow = data => ({ type: LOAD_FAILED, data });
export const requestLoadWorkflow = ({ workflowId }) => ({ type: LOAD_REQUESTED, data: { workflowId } });
export const updateManyWorkflows = data => ({ type: UPDATE_MANY, data });

export const requestWorkflowCreate = (data, resolve, reject) => ({ type: CREATE_REQUESTED, data, resolve, reject });
export const requestWorkflowUpdate = (data, resolve, reject) => ({ type: UPDATE_REQUESTED, data, resolve, reject });
export const succeedWorkflowCreate = data => ({ type: CREATE_SUCCEEDED, data });
export const succeedWorkflowUpdate = data => ({ type: UPDATE_SUCCEEDED, data });
export const failWorkflowCreate = data => ({ type: CREATE_FAILED, data });
export const failWorkflowUpdate = data => ({ type: UPDATE_FAILED, data });
export const requestWorkflowArchive = (data, resolve, reject) => ({ type: ARCHIVE_REQUESTED, data, resolve, reject });
export const succeedWorkflowArchive = data => ({ type: ARCHIVE_SUCCEEDED, data });
export const failWorkflowArchive = data => ({ type: ARCHIVE_FAILED, data });
